import { createSlice } from "@reduxjs/toolkit";
import { fetchProfileData } from "./ProfileApi";

const fetchProfileDataSlice = createSlice({
  name: "fetchProfileData",
  initialState: {
      data: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchProfileData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfileData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default fetchProfileDataSlice.reducer;
